(() => {
  const u_OnMutate = (targetNodes, callback) => {
    var observer = new MutationObserver(callback);
    // Notify me of everything!
    var observerConfig = {
      attributes: true,
      childList: true,
      characterData: true
    };
    targetNodes.forEach(node => {
      observer.observe(node, observerConfig);
    });
    return observer;
  }  
  
  let $rcWidgetParent = document.querySelector('.rc-widget-injection-parent');
  const PLAN_ID_20_OFF = '692215218481';
  if ($rcWidgetParent) {
    let template = $rcWidgetParent.dataset.template;
    u_OnMutate([$rcWidgetParent], (mutations) => {
      // on recharge widget load, hide the 20% selling plan option (specific to colostrum-powder)
      if (template !== 'colostrum-powder-v2') {
        // console.log(mutations);
        let $rcWidget = mutations[0].target;
        let $rcWidgetOptions = $rcWidget.querySelectorAll('option');
        $rcWidgetOptions.forEach(option => {
          if (option.value === PLAN_ID_20_OFF) {
            option.setAttribute('hidden', 'true');
          }
        });
      }
      else {
        // if template is colostrum-powder-v2, show the 20% selling plan option, and hide others
        let $rcWidget = mutations[0].target;
        let $rcWidgetOptions = $rcWidget.querySelectorAll('option');
        let $rcSelect = $rcWidget.querySelector('select.rc-selling-plans__dropdown');
        $rcSelect.value = PLAN_ID_20_OFF;
        $rcSelect.dispatchEvent(new Event('change', {bubbles: true}));
        $rcWidgetOptions.forEach(option => {
          if (option.value !== PLAN_ID_20_OFF) {
            option.setAttribute('hidden', 'true');
          }
        });
      }
    });
  }

  if (!customElements.get('mm-custom-picker')) {
    class MmCustomPicker extends HTMLElement {
      constructor() {
        super();
        this._onCardClick = this._onCardClick.bind(this);
        this._onSubscribeChange = this._onSubscribeChange.bind(this);
      }
  
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;
  
        this.productMain = this.closest('.product-main-element');
        this.planId = this.dataset.subscriptionPlanId || '';
  
        this.querySelectorAll('.mm-custom-picker__card').forEach((card) => {
          card.addEventListener('click', this._onCardClick);
        });
  
        const subscribeInput = this.querySelector('[data-mm-picker-subscribe]');
        if (subscribeInput) {
          subscribeInput.addEventListener('change', this._onSubscribeChange);
          if (subscribeInput.checked) this.updatePlan(true);
        }
  
        const qtyInput =
          this.productMain && this.productMain.querySelector('[name="quantity"]');
        const initialQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (initialQty > 1) {
          setTimeout(() => {
            this.updateQuantity(initialQty);
            this.updateDisplayedPrices(initialQty);
          }, 100);
        } else {
          this.updateDisplayedPrices(this.getCurrentQuantity());
        }

        // remove recharge widget if template is colostrum-powder-v2
        let template = this.dataset.template;
        if (template === 'colostrum-powder-v2') {
          u_OnMutate([this.productMain.querySelector('.shopify-product-form')], (mutations) => {    
            let $rechargeWidget = document.querySelector('.rc-container-wrapper');
            if ($rechargeWidget) {
              $rechargeWidget.remove();
              // disconnect the observer
              observer.disconnect();
            }
          });
        }
      }
  
      disconnectedCallback() {
        this._initialized = false;
        this.querySelectorAll('.mm-custom-picker__card').forEach((card) => {
          card.removeEventListener('click', this._onCardClick);
        });
        const subscribeInput = this.querySelector('[data-mm-picker-subscribe]');
        if (subscribeInput) {
          subscribeInput.removeEventListener('change', this._onSubscribeChange);
        }
      }
  
      _onCardClick(event) {
        const card = event.currentTarget;
        const qty = parseInt(card.dataset.qty, 10);
        this.updateQuantity(qty);
        this.updateDisplayedPrices(qty);
      }
  
      _onSubscribeChange(event) {
        this.updatePlan(event.target.checked);
        this.updateDisplayedPrices(this.getCurrentQuantity());
      }

      getCurrentQuantity() {
        const qtyInput =
          this.productMain && this.productMain.querySelector('[name="quantity"]');
        if (qtyInput && qtyInput.value) {
          const q = parseInt(qtyInput.value, 10);
          if (q > 0) return q;
        }
        const selected = this.querySelector('.mm-custom-picker__card--selected');
        if (selected) {
          const q = parseInt(selected.dataset.qty, 10);
          if (q > 0) return q;
        }
        return 1;
      }

      isSubscribed() {
        const el = this.querySelector('[data-mm-picker-subscribe]');
        return !!(el && el.checked);
      }
  
      updateQuantity(qty) {
        const productMain = this.productMain;
        const qtyInput = productMain && productMain.querySelector('[name="quantity"]');
        if (qtyInput) qtyInput.value = qty;
  
        this.querySelectorAll('.mm-custom-picker__card').forEach((card) => {
          card.classList.toggle(
            'mm-custom-picker__card--selected',
            parseInt(card.dataset.qty, 10) === qty
          );
        });
        this.querySelectorAll('input[name="mm_picker_quantity"]').forEach((radio) => {
          radio.checked = parseInt(radio.value, 10) === qty;
        });
  
        if (productMain) {
          productMain.dispatchEvent(
            new CustomEvent('quantityChange', { detail: { quantity: qty } })
          );
        }
      }
  
      updatePlan(subscribe) {
        const planInput = this.querySelector('[name="selling_plan"]');
        if (planInput) planInput.value = subscribe ? this.planId : '';
  
        const productMain = this.productMain;
        if (productMain && productMain.sellingPlanElement) {
          productMain.sellingPlanElement.dispatchEvent(
            new CustomEvent('planChange', {
              detail: { planId: subscribe ? this.planId : null }
            })
          );
        }
      }
  
      updateDisplayedPrices(qty) {
        const unitPrice = parseInt(this.dataset.unitPrice, 10);
        if (!unitPrice || typeof $s === 'undefined' || !$s.formatMoney) return;

        // Subscription checkbox: show line total with 20% off (matches typical subscribe & save messaging).
        const subscribeMultiplier = this.isSubscribed() ? 0.8 : 1;
        const totalCents = Math.round(unitPrice * qty * subscribeMultiplier);
        const formatted = $s.formatMoney(totalCents).replace('.00', '');
        const productMain = this.productMain;
  
        if (productMain) {
          productMain.querySelectorAll('product-price .btn-p').forEach((el) => {
            el.textContent = formatted;
          });
        }
  
        const rechargePrice = document.querySelector('.recharge-inner-most-price');
        if (rechargePrice) {
          rechargePrice.textContent = formatted;
        }
      }
    }
  
    customElements.define('mm-custom-picker', MmCustomPicker);
  }  
})();